var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconCheckOrange(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4722_13119)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.046 3.0477C17.904 1.2357 15.096 0.0957031 12 0.0957031C8.904 0.0957031 6.096 1.2357 3.954 3.0477C1.524 5.2377 0 8.4297 0 11.9517C0 16.3317 2.286 20.0937 5.76 22.2357C7.572 23.2857 9.714 23.9037 12 23.9037C14.286 23.9037 16.428 23.2857 18.24 22.2357C21.714 20.1417 24 16.3317 24 11.9997C24 8.4297 22.476 5.2377 20.046 3.0477ZM10.05 18.2397L4.194 12.4317L5.526 11.0997L10.05 15.5277L18.618 7.1397L19.95 8.4717L10.05 18.2397Z",
    fill: "#FBA03D"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4722_13119"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCheckOrange);
export default __webpack_public_path__ + "static/media/IconCheckOrange.0f4d885f6d3b56c1113d9639dc89449f.svg";
export { ForwardRef as ReactComponent };